import defaultScripts from "./defaultWebsiteScript.js";

const HREF = window.location.href;

(function () {
    //Check Login Route, User CreatePass Route
    if (
        HREF.includes("/login") ||
        HREF.includes("/usercreatepass") ||
        HREF.includes("/professional") ||
        HREF.includes("/entrar")
    ) {
        //Check Error Message
        document.addEventListener("DOMContentLoaded", function () {
            //Check if the Error Element exist
            if (
                document.querySelector(".alert-danger") ||
                document.querySelector(".alert-success")
            ) {
                setTimeout(function () {
                    ["danger", "success"].forEach((value) => {
                        [
                            ...document.querySelectorAll(`.alert-${value}`),
                        ].forEach((valalert) => valalert.remove());
                    });
                }, 10000);
            }

            return;
        });

        //Show Password
        document
            .querySelector(".showpass")
            .addEventListener("click", function (e) {
                //Check if password input is not empty
                defaultScripts.showPassword(
                    document.getElementById("mailpassword"),
                    this
                );
            });

        //Show Login And Recuperar Senha
        if (document.querySelector(".forgot_pass")) {
            $(".forgot_pass").on("click", function () {
                //Get Form Indicate
                let formHide = this.getAttribute("data-formhide");
                let formShow = this.getAttribute("data-formshow");

                //Remove Old Alert
                ["danger", "success"].forEach((value) => {
                    if (document.querySelector(`.alert-${value}`)) {
                        [
                            ...document.querySelectorAll(`.alert-${value}`),
                        ].forEach((valalert) => valalert.remove());
                    }
                });

                //Hide Form
                if (
                    !document
                        .querySelector(`.${formHide}`)
                        .classList.contains("d-none")
                ) {
                    document
                        .querySelector(`.${formHide}`)
                        .classList.add("d-none");
                    document
                        .querySelector(`.${formShow}`)
                        .classList.remove("d-none");
                } else {
                    document
                        .querySelector(`.${formHide}`)
                        .classList.remove("d-none");
                    document
                        .querySelector(`.${formShow}`)
                        .classList.add("d-none");
                }
            });
        }
    }
})();
